import gcf from 'common/js/global';

export default {
    productList: [],
    page: 1,
    pageSize: 10,
    noMore: false, //暂无更多数据显示
    isRequestSuccess: false, //商品列表是否请求成功
    keyword: "", //搜索关键字
    selectSearchType: 1, //选中的商品类型
    selectSort: '', //选中的排序方式 排序字段,销量-sales_volume,上架时间-on_shelf_time_unix 默认销量排序
    sortType: '', //排序类型,desc-降序,asc-升序
    searchSource: "", //页面来源，区分是关键字搜索还是三级分类搜索 keyword代表关键字搜索
    isWobble: false, //加车晃动
    oldKeyWord: '', // 纠错后的关键字
    reCorrect: false, // 纠错入参
    pageCount: 1 // 总页数
}


// WEBPACK FOOTER //
// ./src/store/search-bar/state.js